import { Box, Text, VStack } from '@chakra-ui/react';
import React from 'react';

const AspectRatio = () => {
  return (
    <VStack
      h="60vh"
      display="flex"
      alignItems="end"
      justifyContent="flex-start"
      flexDirection="row"
    >
      <Box  
      display="flex"
      alignItems="center"
      justifyContent="flex-start"
      flexDirection="row"
      flexWrap="wrap">
        {/* 1:1 */}
        <Box
          bg="#F5F5F5"
          boxShadow="0px 4px 4px 2px rgba(0, 0, 0, 0.15)"
          h="64px"
          w="105px"
          textAlign="center"
          display="flex"
          alignItems="center"
          justifyContent="center"
          marginRight="20px"
        >
          <Text color="rgba(0, 0, 0, 0.84)" fontWeight="500" fontSize="18px">
            1:1
          </Text>
        </Box>

        {/* 4:3 */}
        <Box
          bg="#F5F5F5"
          boxShadow="0px 4px 4px 2px rgba(0, 0, 0, 0.15)"
          h="64px"
          w="145px"
          textAlign="center"
          display="flex"
          alignItems="center"
          justifyContent="center"
          marginRight="20px"
        >
          <Text color="rgba(0, 0, 0, 0.84)" fontWeight="500" fontSize="18px">
            4:3
          </Text>
        </Box>

    {/* 4:3 */}
        <Box
          bg="#F5F5F5"
          boxShadow="0px 4px 4px 2px rgba(0, 0, 0, 0.15)"
          h="64px"
          w="145px"
          textAlign="center"
          display="flex"
          alignItems="center"
          justifyContent="center"
          marginRight="20px"
        >
          <Text color="rgba(0, 0, 0, 0.84)" fontWeight="500" fontSize="18px">
            16:9
          </Text>
        </Box>


    {/* 4:3 */}
            <Box
          bg="#F5F5F5"
          boxShadow="0px 4px 4px 2px rgba(0, 0, 0, 0.15)"
          h="64px"
          w="245px"
          textAlign="center"
          display="flex"
          alignItems="center"
          justifyContent="center"
          marginRight="20px"
        >
          <Text color="rgba(0, 0, 0, 0.84)" fontWeight="500" fontSize="18px">
          18 : 12 : 6
          </Text>
        </Box>
      </Box>
    </VStack>
  );
};

export default AspectRatio;
